import { api, type CustomAxiosRequestConfig } from "@/shared/api/client";
import type { AppBuildApp } from "@/entities/app-build/@x/app-device";
import type {
  AppDeviceMetricsDTO,
  AppDeviceSessionDTO,
  AppDeviceTicketDTO,
} from "@/entities/app-device/model/types";

// A tela consulta a cada poucos segundos e mostra os erros ela mesma.
const silent: CustomAxiosRequestConfig = { skipErrorToast: true };

const sessionPath = (sessionId: string) => `/app-devices/sessions/${encodeURIComponent(sessionId)}`;

export const appDeviceService = {
  create: async (app: AppBuildApp, runId: number): Promise<AppDeviceSessionDTO> => {
    const response = await api.post<AppDeviceSessionDTO>("/app-devices/sessions", { app, runId }, silent);
    return response.data;
  },

  get: async (sessionId: string): Promise<AppDeviceSessionDTO> => {
    const response = await api.get<AppDeviceSessionDTO>(sessionPath(sessionId), silent);
    return response.data;
  },

  createTicket: async (sessionId: string): Promise<AppDeviceTicketDTO> => {
    const response = await api.post<AppDeviceTicketDTO>(`${sessionPath(sessionId)}/ticket`, undefined, silent);
    return response.data;
  },

  heartbeat: async (sessionId: string): Promise<void> => {
    await api.post(`${sessionPath(sessionId)}/heartbeat`, undefined, silent);
  },

  metrics: async (sessionId: string): Promise<AppDeviceMetricsDTO> => {
    const response = await api.get<AppDeviceMetricsDTO>(`${sessionPath(sessionId)}/metrics`, silent);
    return response.data;
  },

  stop: async (sessionId: string): Promise<AppDeviceSessionDTO> => {
    const response = await api.delete<AppDeviceSessionDTO>(sessionPath(sessionId), silent);
    return response.data;
  },
};
